import { render, staticRenderFns } from "./JdProduct.vue?vue&type=template&id=64e4117e&scoped=true&"
import script from "./JdProduct.vue?vue&type=script&lang=js&"
export * from "./JdProduct.vue?vue&type=script&lang=js&"
import style0 from "./JdProduct.vue?vue&type=style&index=0&id=64e4117e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4117e",
  null
  
)

export default component.exports